import "./Receipt.scss";
import { useContext, useState } from "react";
import { UpdatePrintCount, useGetBillInvoice } from "../../api/get";
import { PopupContext } from "../PopUp/Popup-Context";
import { DocumentContext } from "../BillPage/Document-Context";
import { ToWords } from "to-words";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { BillGenerate } from "../BillGenerate/BillGenrate";
import { useToast } from "../../context/ToasterContext/ToasterContext";
import { ButtonComponent } from "../ButtonComponent/ButtonComponent";
import { ReportType } from "../../EnumValues";
import TaxInvoiceB from "./TaxInvoiceB";
import TaxInvoiceA from "./TaxInvoiceA";
export interface ChequeReceipt {
  cheque_no: string;
  created_at: string;
  cheque_withdraw: boolean;
  user_role_id: number;
  id: number;
  updated_at: string | null;
  issue_date: string;
  amount: number;
  transaction_detail_id: number;
  bank_name: string;
}
export interface billDetailsResponse {
  free_primary_unit: number;
  free_secondary_unit: number;
  secondary_unit_measure: string;
  primary_price: number;
  primary_unit: number;
  primary_unit_measure: string;
  secondary_price: number;
  secondary_unit: number;
  sub_total: number;
  discount: number;
  tax: number;
  total: number;
  product: string;
}

export interface IReceipt {
  bill_user_info: {
    pan: number;
    name: string;
    customer_notes: string;
    mobile_no: number;
    bill_print_date: string;
    bill_miti: string;
    bill_miti_ad: string;
    is_total_discount: boolean | null;
    document_no: string;
    bill_no: string | null;
    bill_print_count: number;
  };

  customer_user_info: {
    pan: number;
    name: string;
    mobile_no: number;
    document_no: string;
    date: string;
    bill_no: string;
    additional_info: {
      address: string;
      city: string;
      additionalProp1: string;
    };
  };

  bill_detail: billDetailsResponse[];

  amount_detail: {
    bank: number;
    cash: number;
    credit: number;
    discount_paid: number;
    discount_received: number;
    purchase: number;
    sub_total: number;
    taxable_amount: number;
    tax_paid: number;
    tax_received: number;
    total_amount: number;
  };

  payment_type: {
    bank: number;
    cash: number;
    credit: number;
  };

  cheque_detail: Array<ChequeReceipt>;
  business_info: {
    name: string;
    pan: number;
    mobile_no: string;
    logo: string;
    id: 4;
    address: string;
  };
}
interface ReciptProps {
  reportType?: ReportType;
}

/**
 * Returns the subdomain from the current URL.
 * e.g. "abc" from "abc.hisab.com" or "" for localhost / no subdomain.
 */
const getSubdomain = (): string => {
  const hostname = window.location.hostname; // e.g. "abc.hisab.com"
  const parts = hostname.split(".");
  // If there are 3+ parts (sub.domain.tld), the first part is the subdomain
  if (parts.length >= 3) {
    return parts[0];
  }
  return "";
};

/** Subdomains that should use the TaxInvoice (new) layout */
const TAX_INVOICE_SUBDOMAINS = ["demo", "osm"];

export const Receipt: React.FC<ReciptProps> = ({
  reportType = ReportType.Sales,
}) => {
  const componentRef = useRef(null);

  const [billProductNumber, setBillProductNumber] = useState("20");
  const [loading, setLoading] = useState(false);
  const { closeModal } = useContext(PopupContext);
  const { documentNumber, setResStatus, langData, language } =
    useContext(DocumentContext);

  const toWords = new ToWords({
    converterOptions: { currency: true, ignoreDecimal: false },
  });

  const { data, isLoading } = useGetBillInvoice(documentNumber);
  const { showErrorMessage } = useToast();
  const printTitle = ["Tax Invoice", "Invoice"];
  const createBillTitle = ["Invoice"];

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforePrint: () => setLoading(true),
    onAfterPrint: () => setLoading(false),
  });

  const handlePrintCount = (document_number: string) => {
    setLoading(true);
    UpdatePrintCount(document_number)
      .then((res) => {
        handlePrint();
        setResStatus?.(false);
      })
      .catch((err) => {
        showErrorMessage("Something Went wrong while printing");
        setLoading(false);
      });
  };

  const userInfo = data && data?.bill_user_info;
  const billDetails = data && data?.bill_detail;
  const amountDetails = data && data?.amount_detail;
  const bankDetails = data && data?.cheque_detail;
  const businessInfo = data && data?.business_info;
  const customerInfo = data && data?.customer_user_info;
  const paymentType = data && data?.payment_type;

  const showFreeData = (billArray: billDetailsResponse[]) => {
    let flag = false;
    if (billArray) {
      billArray.forEach((val) => {
        if (val.free_primary_unit || val.free_secondary_unit) {
          flag = true;
        }
      });
    }

    return flag;
  };

  const isNepali = language === "ne";

  // Common props shared between preview and print components
  const commonInvoiceProps = {
    businessInfo,
    userInfo,
    customerInfo,
    billDetails,
    amountDetails,
    paymentType,
    toWords,
  };

  // Props specific to TaxInvoice1 (ReciptPage-style)
  const taxInvoice1Props = {
    ...commonInvoiceProps,
    bankDetails,
    reportType,
    isNepali,
    langData,
    showFreeData,
    billProductNumber,
  };

  // Determine which component to use based on subdomain
  const subdomain = getSubdomain();
  const ResolvedPrintComponent = TAX_INVOICE_SUBDOMAINS.includes(subdomain)
    ? TaxInvoiceB
    : TaxInvoiceA;

  return (
    <>
      {isLoading || !data ? (
        <BillGenerate />
      ) : (
        <>
          <div className="receipt">
            <div className="receipt-top">
              <div className="d-space-between">
                <>
                  <h4 className="title">Receipt</h4>
                  <input
                    className="form-control font-field"
                    onChange={(e) => {
                      if (e.target.value.length <= 0) {
                        setBillProductNumber("20");
                      } else {
                        setBillProductNumber(e.target.value);
                      }
                    }}
                  />

                  <div className="cancel-icon">
                    <img
                      src={require("../../assets/images/cross.png")}
                      alt="cancel"
                      onClick={() => {
                        setResStatus?.(false);
                        closeModal();
                      }}
                    />
                  </div>
                </>
              </div>
            </div>
            <ResolvedPrintComponent
              title="Invoice"
              invoiceRef={componentRef}
              {...taxInvoice1Props}
            />
            {Number(userInfo?.bill_print_count) <= 0 ? (
              <div style={{ display: "none" }}>
                <div className="print-page" ref={componentRef}>
                  {printTitle.map((itm, idx) => {
                    return (
                      <div
                        key={idx}
                        className={
                          idx !== printTitle.length - 1 ? "page-break" : ""
                        }
                      >
                        <ResolvedPrintComponent
                          title={itm}
                          {...taxInvoice1Props}
                        />
                        <div className="page-break" />
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div style={{ display: "none" }}>
                <div className="print-page" ref={componentRef}>
                  {createBillTitle.map((itm, idx) => {
                    return (
                      <div
                        key={idx}
                        className={
                          idx !== createBillTitle.length - 1 ? "page-break" : ""
                        }
                      >
                        <ResolvedPrintComponent
                          title={itm}
                          {...taxInvoice1Props}
                        />
                        <div className="page-break" />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
          <div className="btn-right">
            <div className="d-end">
              <div>
                <button
                  className="light-secondary mr-16"
                  onClick={() => {
                    closeModal();
                    setResStatus?.(false);
                  }}
                >
                  Back
                </button>
              </div>

              <div>
                <ButtonComponent
                  isLoading={loading}
                  title="Print"
                  onClick={() => {
                    handlePrintCount(documentNumber);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
